<template>
    <div class="row">
      <loading :active.sync="loader.isLoading" :can-cancel="loader.canCancel" :is-full-page="loader.fullPage" :color="loader.color" :height="loader.height" :width="loader.width" :background-color="loader.backgroundColor" :loader="loader.loader"></loading>
      <div class="col-md-12">
        <div class="page-title-box">
          <div class="float-right">
            <ol class="breadcrumb">
              <li class="breadcrumb-item">
                <a href="javascript:void(0);">Locking</a>
              </li>
              <li class="breadcrumb-item active">List</li>
            </ol>
          </div>
          <h4 class="page-title">Locking</h4>
        </div>
        <div class="card">
          <div class="card-body">
            <div class="table-responsive">
            <div class="form-inline ml-auto">
              <div class="button-group">
                <button type="button" class="btn btn-outline-primary btn-sm dropdown-toggle" data-toggle="dropdown">
                  <i class="fa fa-filter" aria-hidden="true"></i>
                    Filter
                    <span class="caret"></span>
                </button>
                <ul class="dropdown-menu p-2" >
                  <span>Status:</span>
                  <div class="dropdown-divider"></div>
                  <li><a href="#" class="small" tabIndex="-1"><input type="checkbox" value="completed" v-model="filterStatus"/>&nbsp; Completed</a></li>
                  <li><a href="#" class="small" tabIndex="-1"><input type="checkbox" value="create" v-model="filterStatus"/>&nbsp; Create</a></li>
                  <span>Type:</span>
                  <div class="dropdown-divider"></div>
                  <li><a href="#" class="small" tabIndex="-1"><input type="checkbox" value="inventory" v-model="filterType"/>&nbsp; Inventory</a></li>
                  <li><a href="#" class="small" tabIndex="-1"><input type="checkbox" value="sales" v-model="filterType"/>&nbsp; Sales</a></li>
                  <li><a href="#" class="small" tabIndex="-1"><input type="checkbox" value="report" v-model="filterType"/>&nbsp; Report</a></li>
                </ul>
                <button type="button" class="btn btn-sm  btn-soft-primary waves-light waves-effect" @click="refreshLock">
                  <i class="fa fa-refresh" aria-hidden="true"></i>
                </button>
                rows:
                <select id="select-rows" v-model="pageSize" @change="setPageSizeOnChange">
                  <option v-for="r in rowsTable" :key="r.row" :value="r.row">{{ r.row }}</option>
                </select>
                <span class="mr-1">
                  Total rows: <b>{{ rowsTotal }}</b>
                </span>
                <date-picker v-model="startDate" type="date" range placeholder="Select date range" @change="refreshLock"></date-picker>
              </div>
              <div class="form-group mx-sm-3 mb-2">
                <input type="search" placeholder="search..." class="form-control mr-1 input-search" v-model="searchQuery">
              </div>
              <span class="mr-1">
                page:
                <select v-model="currentPage">
                  <option v-for="p in pageLength" :key="p" :value="p">{{ p }}</option>
                </select>
                / {{ pageLength }}
              </span>
              <nav aria-label="Page navigation example" class="pull-right">
                  <ul class="pagination">
                      <li class="page-item">
                          <a class="btn btn-default btn-sm" href="#" @click="prevPage">
                              <i class="fa fa-angle-left" aria-hidden="true"></i>
                          </a>
                      </li>
                      <li class="page-item">
                          <a class="btn btn-default btn-sm" href="#" @click="nextPage">
                              <i class="fa fa-angle-right" aria-hidden="true"></i>
                          </a>
                      </li>
                  </ul>
              </nav>
            </div>
            <table class="table table-item mb-0 table-sm">
                <thead>
                    <tr>
                        <th>
                        <label class="form-checkbox">
                            <input type="checkbox" v-model="selectAll">
                            <i class="form-icon"></i>
                        </label>
                        </th>
                        <th  v-for="t in title" v-bind:key="t.prop" @click="sortTable(t.prop)">
                            {{ t.name }}
                            <div class="float-right fa" v-if="t.prop == sortColumn" v-bind:class="ascending ? 'fa-arrow-up' : 'fa-arrow-down'"></div>
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-if="fiterData.length < 1">
                        <td colspan="9" style="text-align: center;"><i>No Data</i></td>
                    </tr>
                    <tr v-for="d in fiterData" :key="d.id">
                      <td>
                          <label class="form-checkbox">
                              <input type="checkbox" :value="d.id" v-model="selected">
                              <i class="form-icon"></i>
                          </label>
                      </td>
                      <td>
                        <span v-if="d.type === 'purchasing-void'" class="badge badge-danger">Purchasing Delete</span>
                        <span v-else-if="d.type === 'purchasing-order-void'" class="badge badge-danger">Purchasing Order Delete</span>
                        <span v-else-if="d.type === 'sales-order-void'" class="badge badge-danger">Sales Order Delete</span>
                        <span v-else-if="d.type === 'sales-void'" class="badge badge-danger">Sales Delete</span>
                        <span v-else-if="d.type === 'manufacture-void'" class="badge badge-danger">Manufacture Delete</span>
                        <span v-else-if="d.type === 'purchasing'" class="badge badge-primary">Purchasing</span>
                        <span v-else-if="d.type === 'sales'" class="badge badge-success">Sales</span>
                        <span v-else-if="d.type === 'manufacture'" class="badge badge-warning">Manufacture</span>
                        <span v-else class="badge badge-info">{{ d.type }}</span>
                      </td>
                      <td><b>{{ d.lock_no }}</b></td>
                      <td>{{ d.lock_date | dateFormat('DD/MM/YYYY H:m:s') }}</td>
                      <td>
                          <span v-if="d.user">{{ d.user.name }}</span>
                      </td>
                      <td>
                          <span v-if="d.request">{{ d.request.name }}</span>
                      </td>
                      <td>{{ d.lock_note }}</td>
                      <td>
                          <span class="badge badge-danger" v-if="d.status === 'voided'">{{ d.status }}</span>
                          <span class="badge badge-success" v-else>{{ d.status }}</span>
                      </td>
                      <td>
                        <span v-if="d.type === 'purchasing-void'">
                          <button class="btn btn-sm btn-danger" type="button" v-if="d.status === 'create'" @click="changelock(d.id , d.type)"><i class="fa fa-trash" aria-hidden="true"></i></button>
                        </span>
                        <span v-else-if="d.type === 'sales-order-void'">
                          <button class="btn btn-sm btn-danger" type="button" v-if="d.status === 'create'" @click="changelock(d.id , d.type)"><i class="fa fa-trash" aria-hidden="true"></i></button>
                        </span>
                        <span v-else-if="d.type === 'sales-void'">
                          <button class="btn btn-sm btn-danger" type="button" v-if="d.status === 'create'" @click="changelock(d.id , d.type)"><i class="fa fa-trash" aria-hidden="true"></i></button>
                        </span>
                        <span v-else-if="d.type === 'purchasing-order-void'">
                          <button class="btn btn-sm btn-danger" type="button" v-if="d.status === 'create'" @click="changelock(d.id , d.type)"><i class="fa fa-trash" aria-hidden="true"></i></button>
                        </span>
                        <span v-else-if="d.type === 'manufacture-void'">
                          <button class="btn btn-sm btn-danger" type="button" v-if="d.status === 'create'" @click="changelock(d.id , d.type)"><i class="fa fa-trash" aria-hidden="true"></i></button>
                        </span>
                        <span v-else-if="d.type === 'sales-return-void'">
                          <button class="btn btn-sm btn-danger" type="button" v-if="d.status === 'create'" @click="changelock(d.id , d.type)"><i class="fa fa-trash" aria-hidden="true"></i></button>
                        </span>
                        <span v-else>
                          <button class="btn btn-sm btn-success" type="button" v-if="d.status === 'create'" @click="changelock(d.id , d.type)"><i class="fa fa-lock" aria-hidden="true"></i></button>
                          <button class="btn btn-sm btn-warning" type="button" v-else @click="changelock(d.id, d.type)"><i class="fa fa-unlock" aria-hidden="true"></i></button>
                          <button class="btn btn-sm btn-danger" type="button" v-show="d.status === 'create'" @click="block(d.id, d.type)"><i class="fa fa-times" aria-hidden="true"></i></button>
                        </span>
                      </td>
                    </tr>
                </tbody>
            </table>
          </div>
          </div>
        </div>
      </div>
      <div>
      </div>
    </div>
</template>

<script>
import axios from 'axios'
import { lockUrl, getHeader } from '@/config'
import { mapState } from 'vuex'
import Loading from 'vue-loading-overlay'
import DatePicker from 'vue2-datepicker'

export default {
  name: 'LockList',
  components: {
    DatePicker,
    Loading
  },
  data () {
    var date = new Date()
    var firstDay = new Date(date.getFullYear(), date.getMonth(), 1)
    var lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0)
    const date1 = new Date(firstDay.getFullYear(), firstDay.getMonth(), firstDay.getDate())
    const date2 = new Date(lastDay.getFullYear(), lastDay.getMonth(), lastDay.getDate())
    return {
      startDate: [date1, date2],
      loader: {
        isLoading: false,
        fullPage: true,
        color: '#007bff',
        canCancel: true,
        height: 128,
        width: 128,
        backgroundColor: '#ffffff',
        loader: 'spinner'
      },
      filterStatus: [],
      filterType: [],
      dataRaw: [],
      data: {},
      searchQuery: '',
      ascending: false,
      sortClick: false,
      sortColumn: '',
      pageSize: 10,
      currentPage: 1,
      title: [{
        name: 'Type',
        prop: 'type'
      }, {
        name: 'Lock No',
        prop: 'lock_no'
      }, {
        name: 'Date',
        prop: 'lock_date'
      }, {
        name: 'User',
        prop: 'username'
      }, {
        name: 'Request By',
        prop: 'request_by'
      }, {
        name: 'Note',
        prop: 'lock_note'
      }, {
        name: 'Status',
        prop: 'status'
      }, {
        name: 'Lock',
        prop: 'lock'
      }],
      selectAll: false,
      selected: []
    }
  },
  mounted () {
    this.$store.dispatch('getRowTable')
    this.refreshLock()
  },
  methods: {
    setPageSizeOnChange: function () {
      this.currentPage = 1
    },
    async changelock (id, type) {
      var obj = { model: type }
      console.log(obj)
      console.log(lockUrl + '/' + id + '?model=' + type)
      const lock = this.dataRaw.find(d => d.id === id)
      await axios.put(lockUrl + '/' + id + '?model=' + type, obj, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
        .then(response => {
          this.$swal('Locking', 'Successfully Unlock this no: ' + response.data.data.lock_no, 'success')
          this.refreshLock()
        })
        .catch(error => {
          console.log(error)
          console.log(error.response)
          this.$swal('Locking', error.response.data.message, 'success')
          throw error
        })
      if (type === 'purchasing-void') {
        await this.$router.push({ path: '/purchasing', query: { form: 'true', purchasing: lock.ref_id } })
      } else if (type === 'purchasing-order-void') {
        await this.$router.push({ path: '/purchasing/order', query: { form: 'true', purchasing: lock.ref_id } })
      } else if (type === 'purchasing-order') {
        await this.$router.push({ path: '/purchasing/order', query: { form: 'true', purchasing: lock.ref_id } })
      } else if (type === 'sales-order-void') {
        await this.$router.push({ path: '/sale/order', query: { refno: lock.ref_id } })
      } else if (type === 'sales-void') {
        await this.$router.push({ path: '/sales', query: { sales: lock.ref_id } })
      } else if (type === 'sales-approve') {
        await this.$router.push({ path: '/sales', query: { sales: lock.ref_id } })
      } else if (type === 'sales-order') {
        await this.$router.push({ path: '/sale/order', query: { refno: lock.ref_id } })
      } else if (type === 'manufacture-void') {
        await this.$router.push({ path: '/manufacture', query: { id: lock.ref_id } })
      } else if (type === 'purchasing-return-void') {
        await this.$router.push({ path: '/purchasing/return', query: { id: lock.ref_id } })
      } else if (type === 'sales-return-void') {
        await this.$router.push({ path: '/sales/return', query: { id: lock.ref_id } })
      } else if (type === 'purchasing-return-void') {
        await this.$router.push({ path: '/purchasing/return', query: { id: lock.ref_id } })
      }
    },
    async block (id, type) {
      var obj = { model: type }
      await axios.put(lockUrl + '/block/' + id + '?model=' + type, obj, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
        .then(response => {
          this.refreshLock()
        })
        .catch(error => {
          console.log(error)
          console.log(error.response)
          this.$swal('Locking', error.response.data.message, 'success')
          throw error
        })
    },
    async refreshLock () {
      this.$Progress.start()
      this.loader.isLoading = true
      const begin = this.startDate[0] ? this.startDate[0].getFullYear() + '-' + (this.startDate[0].getMonth() + 1) + '-' + this.startDate[0].getDate() : null
      const end = this.startDate[1] ? this.startDate[1].getFullYear() + '-' + (this.startDate[1].getMonth() + 1) + '-' + this.startDate[1].getDate() : null
      var url = lockUrl + '?begin=' + begin + '&end=' + end
      await axios.get(url, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
        .then(response => {
          this.dataRaw = response.data.data
          this.$Progress.finish()
          this.loader.isLoading = false
        })
        .catch(error => {
          this.$Progress.fail()
          this.loader.isLoading = false
          console.log(error)
          console.log(error.response)
          this.$swal('Error', error.response.data.message, 'error')
          throw error
        })
    },
    sortTable: function sortTable (col) {
      this.currentPage = 1
      if (this.sortColumn === col) {
        this.ascending = !this.ascending
      } else {
        this.ascending = true
        this.sortColumn = col
      }
    },
    nextPage: function () {
      if ((this.currentPage * this.pageSize) < this.rowsTotal) this.currentPage++
    },
    prevPage: function () {
      if (this.currentPage > 1) this.currentPage--
    },
    select () {
      this.selected = []
      this.currentPage = 1
      if (!this.selectAll) {
        for (const i in this.filterInventory) {
          this.selected.push(this.filterInventory[i].id)
        }
      }
    }
  },
  computed: {
    ...mapState({
      authUser: state => state.users.authUser,
      rowsTable: state => state.data.rowsTable
    }),
    pageLength: function () {
      var count = 0
      if (this.searchQuery.length < 0 || this.searchQuery === null) {
        count = this.dataRaw.length
      } else {
        count = this.dataRaw
          .filter(d => {
            for (const name in d) {
              if (d[name] !== null) {
                if (d[name].toString().toLowerCase().indexOf(this.searchQuery.toLowerCase()) > -1) {
                  return d
                }
              }
            }
          }).length
      }
      var length = count / this.pageSize

      return Math.ceil(length)
    },
    rowsTotal: function () {
      var count = 0
      if (this.searchQuery.length < 0 || this.searchQuery === null) {
        count = this.dataRaw.length
      } else {
        count = this.dataRaw
          .filter(d => {
            for (const name in d) {
              if (d[name] !== null) {
                if (d[name].toString().toLowerCase().indexOf(this.searchQuery.toLowerCase()) > -1) {
                  return d
                }
              }
            }
          }).length
      }
      // console.log(count)
      return count
    },
    fiterData: function () {
      if (this.searchQuery.length > 0) {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      }
      var col = this.sortColumn
      var ascending = this.ascending
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      return this.dataRaw.sort(function (a, b) {
        if (a[col] > b[col]) {
          return ascending ? 1 : -1
        } else if (a[col] < b[col]) {
          return ascending ? -1 : 1
        }
        return 0
      }).filter(d => {
        for (const name in d) {
          if (d[name] !== null) {
            if (d[name].toString().toLowerCase().indexOf(this.searchQuery.toLowerCase()) > -1) {
              return d
            }
          }
        }
      }).filter(d => {
        if (this.filterType.length > 0) {
          for (let i = 0; i < this.filterType.length; i++) {
            if (d.type === this.filterType[i]) {
              return d
            }
          }
        } else {
          return d
        }
      }).filter((row, index) => {
        const start = (this.currentPage - 1) * this.pageSize
        const end = this.currentPage * this.pageSize
        if (index >= start && index < end) return true
      }).filter(d => {
        if (this.filterStatus.length > 0) {
          for (let i = 0; i < this.filterStatus.length; i++) {
            if (d.status === this.filterStatus[i]) {
              return d
            }
          }
        } else {
          return d
        }
      })
    }
  }
}
</script>
